import {
    SEND_EMAIL_VERIFICATION_REQUEST,
    SEND_EMAIL_VERIFICATION_SUCCESS,
    SEND_EMAIL_VERIFICATION_FAILURE
} from './constants';
import { HTTP_METHOD_POST } from '../../constants/httpMethod';

import { CALL_API } from '../../middlewares/api';

export const sendVerificationEmail = payload => {
    return {
        [CALL_API]: {
            endpoint: '/user/email-verification',
            method: HTTP_METHOD_POST,
            types: [
                SEND_EMAIL_VERIFICATION_REQUEST,
                SEND_EMAIL_VERIFICATION_SUCCESS,
                SEND_EMAIL_VERIFICATION_FAILURE
            ],
            body: payload
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/email-verification/actions.js